// @flow

import React from 'react';
import styled from 'styled-components';
import { SmallText, HSpacer, PadlockIcon } from '@e4/ui';
import { logoff } from '../utils/logoff';
import translate from '@e4/intl/translate.macro';

const LogoffContainer = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Logoff = () => {
  return (
    <LogoffContainer onClick={() => logoff()}>
      <SmallText style={{ whiteSpace: 'nowrap' }}>
        {translate('logoff')}
      </SmallText>
      <HSpacer small={0.5} />
      <PadlockIcon />
    </LogoffContainer>
  );
};
